import React from 'react'

import SendEmail from '../../../common/SendEmail'

function SendResetEmail(props) {
  return (
    <SendEmail
      title="passport.resetPassword.expired.title"
      subTitle="passport.resetPassword.expired.subTitle"
      {...props}
    />
  )
}

export default SendResetEmail
